import { IRegionShort } from 'api/region/types';
import Link from 'next/link';
import classNames from 'classnames';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { Routes } from 'routes';
import { useSettingsPrefetch } from 'settings/SettingsContext';
import styles from './styles.module.scss';

export const RegionRelated = (
  { links, className }: { className?: string, links: IRegionShort[] },
) => {
  const prefetch = useSettingsPrefetch();
  const { t } = useOTSTranslation('common');
  return (
    <div className={classNames(styles.box, className)}>
      <div>
        {t('common.relatedRegions')}
      </div>
      {links.map((l) => (
        <Link scroll={false} href={Routes.regionSnowReport(l)} key={l.uuid} prefetch={prefetch}>
          <a href={Routes.regionSnowReport(l)}>
            {l.title}
          </a>
        </Link>
      ))}
    </div>
  );
};
